<template>
  <div class="draggable-window" :style="containerStyle" @mousedown.self="startDrag" @mouseup="stopDrag" @mousemove="drag" v-show="visible" @click="handleWindowClick">
    <div class="draggable-header" @mousedown.stop="startDrag">
      <slot name="title">{{ title }}<a-icon class="close-btn" type="close"  @click="hide()" :style="{ fontSize: '20px' }" /></slot>
    </div>
    <div class="draggable-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DraggableWindow',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '默认标题'
    },
    width: {
      type: Number,
      default: 360
    },
    height: {
      type: Number,
      default: 690
    },
	  zIndex: {
			type: Number,
			default: 1
	  }
  },
  data() {
    return {
      dragging: false,
      offsetX: 0,
      offsetY: 0,
      initialMouseX: 0,
      initialMouseY: 0,
      initialContainerLeft: 0,
      initialContainerTop: 0,
    };
  },
  computed: {
    containerStyle() {
      return {
        position: 'absolute',
        width: `${this.width}px`,
        height: `${this.height}px`,
        border: '1px solid #ccc',
        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
	      zIndex: this.zIndex
      };
    }
  },
  methods: {
	  handleWindowClick() {
		  this.$emit('show');
	  },
    startDrag(event) {
      this.dragging = true;
      this.initialMouseX = event.clientX;
      this.initialMouseY = event.clientY;
      const rect = this.$el.getBoundingClientRect();
      this.initialContainerLeft = rect.left;
      this.initialContainerTop = rect.top;
      document.addEventListener('mousemove', this.drag);
      document.addEventListener('mouseup', this.stopDrag);
    },
    drag(event) {
      if (this.dragging) {
        const newLeft = this.initialContainerLeft + (event.clientX - this.initialMouseX);
        const newTop = this.initialContainerTop + (event.clientY - this.initialMouseY);
        this.$el.style.left = `${newLeft}px`;
        this.$el.style.top = `${newTop}px`;
        this.$el.style.transform = 'none';
      }
    },
    stopDrag() {
      this.dragging = false;
      document.removeEventListener('mousemove', this.drag);
      document.removeEventListener('mouseup', this.stopDrag);
    },
    hide() {
      this.$emit('close'); // 触发自定义关闭事件
    }
  }
};
</script>

<style scoped lang="less">
.draggable-window {
  position: absolute;
  border-radius: 6px;
  z-index: 11;
  background: white;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
	user-select: none;
  .draggable-header {
    font-size: 16px;
    padding: 13px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: move;
    .ant-btn {
      border-radius: 16px;
      border-color: rgb(250 250 250);
      font-size: 16px;
      color: #191919;
      img {
        height: 18px;
      }
      &:hover {
        background: rgb(242,242,242);
      }
      &:first-child {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
      &:last-child {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        border-left-color: transparent;
      }
    }
  }
  .draggable-content {
    height: calc(100% - 50px);
  }
}
</style>
